import { Checkbox, Menu } from '@mantine/core'
import type { TColumn } from 'components/SummaryTable/SummaryTable.types'
import { translate } from 'i18n/i18n'
import { colors } from 'settings/colors'

export const ColumnVisibilityMenu = ({
  columns,
  visibleColumns,
  onToggle,
  onToggleAll,
}: {
  columns: TColumn[]
  visibleColumns: Record<string, boolean>
  onToggle: (key: string) => void
  onToggleAll: () => void
}) => {
  return (
    <Menu.Dropdown>
      <Menu.Label css={{ color: 'black', fontWeight: 'bolder' }}>
        {translate.phrases.banyanApp('Show/Hide Columns')}
      </Menu.Label>
      <Menu.Item>
        <div onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation()}>
          <Checkbox
            css={{ color: colors.primary, fontWeight: '500' }}
            checked={Object.values(visibleColumns).every((v) => v !== false)}
            onChange={onToggleAll}
            label={translate.phrases.banyanApp('View All')}
            size="xs"
            styles={{
              input: {
                '&:checked': {
                  backgroundColor: colors.primary,
                  borderColor: colors.primary,
                },
              },
            }}
          />
        </div>
      </Menu.Item>

      {columns.map((column) => (
        <Menu.Item key={column.key}>
          <div onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation()}>
            <Checkbox
              css={{ color: colors.primary, fontWeight: '500' }}
              checked={visibleColumns[column.key] !== false}
              onChange={() => onToggle(column.key)}
              label={column.title}
              size="xs"
              styles={{
                input: {
                  '&:checked': {
                    backgroundColor: colors.primary,
                    borderColor: colors.primary,
                  },
                },
              }}
            />
          </div>
        </Menu.Item>
      ))}
    </Menu.Dropdown>
  )
}
